const Vuex = require('vuex');
const {MUTATION} = require('./mutation-types');
const {ACTION} = require('./action-types');
const {CartAPI} = require('../api/carts');

const state = {
    status: {
        is_loading: false,
        is_checked: true,
        is_purchaseable: true, // チェックアウトに遷移しても大丈夫か
        is_device_pc: ObHelper.judgeDevice(),
        has_error: false
    },
    carts: carts,
    errors: json.errors,
    upsells: json.upsell,
    news_images: json.news_images,
    checkout_url: checkout_url,
    alpha: {
        regular_codes: json.consts.FrontAlphaConst.REGULAR_ALPHA,
        regular_patterns: json.regular_alpha_patterns,
    },
    sasa_veitchii: {
        regular_codes: json.consts.FrontSasaVeitchiiConst.REGULAR_SASA_VEITCHII,
        regular_patterns: json.regular_sasa_veitchii_patterns,
    },
    good_bacteria: {
        regular_codes: json.consts.FrontGoodBacteriaConst.REGULAR_GOOD_BACTERIA,
        regular_patterns: json.regular_good_bacteria_patterns,
    },
    bee_care_rj: {
        regular_codes: json.consts.FrontBeeCareRjConst.REGULAR_BEE_CARE_RJ,
        regular_patterns: json.regular_bee_care_rj_patterns,
    },
    pain_pro: {
        regular_codes: json.consts.FrontPainProConst.REGULAR_PAIN_PRO,
        regular_patterns: json.regular_pain_pro_patterns,
    },
    cognitive_power: {
        regular_codes: json.consts.FrontCognitivePowerConst.REGULAR_COGNITIVE_POWER,
        regular_patterns: json.regular_cognitive_power_patterns,
    },
    tmp_combination: {},
    total_discount_price: json.total_discount_price,
    response: {},
    messages: {
        purchaseable_limit: '購入可能な商品数を上回っております。数量の変更をお願いします。',
        unpurchasable: '合計金額が0円を下回っているため、購入することができません。', // 仮メッセージ
        purchasable: 'カートの中身をご確認の上、「お会計はこちら」ボタンを押してください。' // 通常
    },
    regular_cycle_type: json.regular_cycle_type,
    regular_cycle_const: json.consts.RegularsCycleConst,
    front_alpah_const: json.consts.FrontAlphaConst,
    front_sasa_veitchii_const: json.consts.FrontSasaVeitchiiConst,
    front_good_bacteria_const: json.consts.FrontGoodBacteriaConst,
};

const getters = {};

const actions = {
    [ACTION.DELETE_CART] ({commit}, cart_id) {
        return CartAPI.delete(cart_id, (response) => {
            commit(MUTATION.SET_DELETE_CART, {res: response, id: cart_id});
        });
    },
    [ACTION.UPDATE_CART] ({commit}, content) {
        return CartAPI.update(content, (response) => {
            commit(MUTATION.SET_UPDATE_CART, response);
        });
    },
    [ACTION.CHECK_COMBINATION] ({commit}, content) {
        return CartAPI.check_combination(content, (response) => {
            commit(MUTATION.SET_COMBINATION, response);
            commit(MUTATION.SET_TOTAL_DISCOUNT_PRICE, response);
        });
    },
    [ACTION.UPSELL_CART] ({commit}, content) {
        return CartAPI.upsell(content, (response) => {
            commit(MUTATION.SET_UPDATE_CART, response);
        });
    }
};

const mutations = {
    [MUTATION.SET_DELETE_CART] (state, payload) {
        if (payload.res.status == false) {
            state.status.messages = payload.res.messages;
        } else {
            let carts = state.carts;
            state.carts = carts.filter((cart) => {
                return cart.id !== payload.id;
            });
        }
    },
    [MUTATION.SET_UPDATE_CART] (state, response) {
        state.response = response;
    },
    [MUTATION.SET_COMBINATION] (state, response) {
        state.tmp_combination = response.codes;
    },
    [MUTATION.SET_TOTAL_DISCOUNT_PRICE] (state, response) {
        state.total_discount_price = response.total_discount;
    },
    [MUTATION.SET_IS_PURCHASEABLE] (state, total_price) {
        // 合計金額が0より大きいかつ、ローディング中ではないこと
        state.status.is_purchaseable = total_price > 0 && ! state.status.is_loading;
    },
    [MUTATION.SET_HAS_ERROR] (state) {
        // 合計金額が0より大きいかつ、ローディング中ではないこと
        if(state.errors.status){
            state.status.has_error = true;
        }
    },

};

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations
});



// WEBPACK FOOTER //
// ./resources/assets/js/front/cart/store/index.js